<template>
  <div>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3">
        <DateRange v-model="dates" />
      </v-col>
      <v-col cols="3">
        <v-text-field v-model="search" prepend-inner-icon="mdi-magnify"></v-text-field>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="filteredItems"
      :search="search"
      :page.sync="currentPage"
      class="transparent"
      show-expand
      single-expand
      item-key="messageKey"
      :footer-props="foot_props"
      :no-data-text="$t('label.nodata')"
    >
      <template v-slot:expanded-item="{headers, item}">
        <td :colspan="headers.length">
          <v-row>
            <v-col cols="12">{{item.text}}</v-col>
            <v-col cols="12">
              <v-layout>
                <v-flex
                  v-for="k in ['provider','country','responseCode','responseText','ok','messageId']"
                  :key="k"
                >
                  <span>{{k}}</span>
                  <span>=</span>
                  <span>{{item[k]}}</span>
                </v-flex>
              </v-layout>
            </v-col>
          </v-row>
        </td>
      </template>

      <template v-slot:item.status="{item}">{{$t("status.rec_"+item.status)}}</template>
      <template v-slot:item.rprice="{item}">{{item.rprice | currency4}}</template>
      <template v-slot:item.cprice="{item}">{{item.cprice | currency4}}</template>
      <template v-slot:item.sended="{item}">{{item.sended | dt-time}}</template>
      <template v-slot:item.created="{item}">{{item.created | dt-time}}</template>
      <template v-slot:item.updated="{item}">{{item.updated | dt-time}}</template>
      <template v-slot:item.company="{item}">{{$store.getters['admin/company'](item.company).name}}</template>
    </v-data-table>
  </div>
</template>

<script>
import commonmixin from "@/mixins/commonlist.js";
import DateRange from "@/components/DateRange.vue";

export default {
  name: "Messages",
  components: { DateRange },
  mixins: [commonmixin],
  data() {
    return {
      headers: [
        { text: this.$t("fields.task"), value: "task" },
        //        { text: this.$t("fields.company"), value: "company" },
        //        { text: this.$t("fields.country"), value: "country" },
        //        { text: this.$t("fields.messageId"), value: "messageId" },
        { text: this.$t("fields.number"), value: "number" },
        //        { text: this.$t("fields.ok"), value: "ok" },
        //       { text: this.$t("fields.provider"), value: "provider" },
        //       { text: this.$t("fields.responseCode"), value: "responseCode" },
        //       { text: this.$t("fields.responseText"), value: "responseText" },
        { text: this.$t("fields.rparts"), value: "rparts" },
        { text: this.$t("fields.cparts"), value: "cparts" },
        { text: this.$t("fields.rprice"), value: "rprice" },
        { text: this.$t("fields.cprice"), value: "cprice" },
        { text: this.$t("fields.created"), value: "created" },
        { text: this.$t("fields.updated"), value: "updated" },
        { text: this.$t("fields.sended"), value: "sended" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
  methods: {
    loadData() {
      this.$api.getAdminMessages().then((response) => {
        this.items = response;
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style>
</style>